import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LogoutPopupComponent } from '../../../../core/libraries/popup/components/logout-popup/logout-popup.component';
import { SearchPopupComponent } from '../../../../core/libraries/popup/components/search-popup/search-popup.component';

@Component({
    selector: 'app-header',
    standalone: false,
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
})
export class HeaderComponent {
    @Output() toggleSidebar = new EventEmitter<void>();

    constructor(
        private dialog: MatDialog,
        private router: Router,
    ) {}

    protected openSearchPopup(): void {
        const popupConfig = SearchPopupComponent.getDialogConfig();
        this.dialog.open(SearchPopupComponent, popupConfig);
    }

    protected openSignOutPopup(): void {
        const popupConfig = LogoutPopupComponent.getDialogConfig();
        const dialogRef = this.dialog.open(LogoutPopupComponent, popupConfig);
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.router.navigate(['logout']);
            }
        });
    }
}
